<template>
  <div class="nav">
    <router-link to="/medical"
      ><div class="logo">스키넥스 expert</div></router-link
    >
    <router-link
      to="/medical"
      :class="active === 'medical' ? 'nav__menu--active' : 'nav__menu'"
      @click="(active = 'medical'), goMedical()"
      ><div>의료진 관리</div></router-link
    >
    <router-link
      to="/patient"
      :class="active === 'patient' ? 'nav__menu--active' : 'nav__menu'"
      @click="(active = 'patient'), goPatient()"
      ><div>환자 관리</div></router-link
    >
    <router-link
      to="/dressing"
      :class="active === 'dressing' ? 'nav__menu--active' : 'nav__menu'"
      @click="(active = 'dressing'), goDressing()"
      ><div>드레싱 사진 관리</div></router-link
    >
    <router-link
      to="/log"
      :class="active === 'log' ? 'nav__menu--active' : 'nav__menu'"
      @click="(active = 'log'), goLogPage()"
      ><div>로그 관리</div></router-link
    >
  </div>
</template>

<script>
import { useRoute } from "vue-router";
export default {
  name: "WebNav",
  data() {
    return {
      active: "medical",
    };
  },
  computed: {
    getUrl() {
      let url = window.location.pathname;
      return url;
    },
  },
  created() {
    this.setNav();
  },

  methods: {
    setNav() {
      let activeState = "";
      const route = useRoute();
      const id = route.params.id;
      if (
        this.getUrl === "/medical" ||
        this.getUrl === "/addMedical" ||
        this.getUrl === "/medicalUpdate"
      )
        activeState = "medical";
      else if (
        this.getUrl === "/patient" ||
        this.getUrl === "/addPatient" ||
        this.getUrl === `/patientDetail/${id}` ||
        this.getUrl === "/patientUpdate"
      )
        activeState = "patient";
      else if (this.getUrl === "/dressing") activeState = "dressing";
      else if (this.getUrl === "/log") activeState = "log";
      return (this.active = activeState);
    },
    goMedical() {
      window.location.href = "/medical";
    },
    goPatient() {
      window.location.href = "/patient";
    },
    goDressing() {
      window.location.href = "/dressing";
    },
    goLogPage() {
      window.location.href = "/log";
    },
  },
};
</script>

<style lang="scss" scoped>
.logo {
  font-size: 20px;
  font-weight: 600;
  color: #4087de;
  height: 60px;
  line-height: 60px;
  padding: 0 40px;
}
.nav {
  width: 300px;
  min-width: 300px;
  height: 100%;
  background: #fff;
  border-right: 1.5px solid #1f3d6825;
  div {
    text-align: left;
  }
  &__menu {
    width: 100%;
    height: 50px;
    line-height: 50px;
    color: #1d4d88;
    div {
      margin: 10px 20px;
      padding: 0 20px;
    }
  }
  &__menu--active {
    width: 100%;
    height: 50px;
    text-align: center;
    line-height: 50px;

    div {
      background: #4087de;
      color: #fff;
      margin: 10px 20px;
      padding: 0 20px;
      box-shadow: 1px 5px 10px 2px #e5f0ff;
      border-radius: 10px;
    }
  }
}
</style>
